<template>
    <div>
        <div>{{ label }}</div>
        <div class="fileUploadArea">
            <div class="uploadHint">
                <icon value="hero_Inbox"/>
                <div class="hint-text">Click or Drag</div>
                <div>{{ preferedSize ? `${preferedSize[0]} x ${preferedSize[1]} px` : '' }}</div>
            </div>
            <input
                ref="fileInput"
                type="file"
                :accept="accept"
                @change="onFileSelect"/>
        </div>
        <div
            v-if="displayImage"
            class="display-selected d-flex pa-2 my-2">
            <div class="d-flex align-center">
                <img :src="displayImage" class="mr-4"/>
                <div>{{ displayFileName }}</div>
            </div>

            <icon
                class="grey--text lighten-1 clickable"
                value="hero_Trash"
                @click="removeSelectedFile"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FileUploadField',

    props: {
        value: {
            type: [File, String],
            default: null
        },

        defaultFile: {
            type: [File, String],
            default: null
        },

        defaultDisplayFileName: {
            type: String,
            default: null
        },

        label: {
            type: String,
            default: ''
        },

        accept: {
            type: String,
            default: 'image/png, image/jpeg'
        },

        imageFile: {
            type: Boolean,
            default: false
        },

        preferedSize: {
            type: Array,
            default: null
        }
    },

    computed: {
        displayImage () {
            if (this.value) {
                if (this.value?.constructor === File) {
                    return URL.createObjectURL(this.value)
                }
                return this.value
            }

            if (this.defaultFile?.constructor === File) {
                return URL.createObjectURL(this.value)
            }

            return this.defaultFile !== 'null' ? this.defaultFile : false
        },

        displayFileName () {
            return this.value?.name ?? this.defaultDisplayFileName
        }
    },

    methods: {
        async onFileSelect (event) {
            const file = this.$refs.fileInput.files?.[0]
            event.target.value = null

            if (this.imageFile && this.preferedSize) {
                const width = this.preferedSize?.[0]
                const height = this.preferedSize?.[1] ?? this.preferedSize?.[0]

                const image = await this.$util.fileToImage(file)

                if (width !== image.width && height !== image.height) {
                    this.$emit('image-size-mismatch', image)
                }
            }

            this.$emit('update:defaultFile', null)
            this.$emit('input', file)
        },

        removeSelectedFile () {
            this.$emit('update:defaultFile', null)
            this.$emit('input', null)
        }
    }
}
</script>

<style lang="scss" scoped>
.fileUploadArea {
    width: 100%;
    height: 200px;
    border: 2px dashed #00000042;
    display: flex;
    justify-content: center;
    position: relative;

    .uploadHint {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #00000042;
        .hint-text {
            font-size: 16px;
            text-align: center;
            font-weight: bold;
        }
    }

    input {
        width: 100%;
        height: 200px;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.display-selected {
    justify-content: space-between;
    align-items: center;
    border: 1px solid #00000042;
    img {
        width: 80px;
        height: 80px;
        object-fit: cover;
    }
}
</style>
